import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Card,
  Modal,
  Text,
  FormLayout,
  Filters,
  TextField,
  Badge,
  Frame,
  InlineError,
  ChoiceList,
  Thumbnail,
  EmptySearchResult,
  Link,
  Select,
  Toast,
  Spinner,
  Button,
  PageActions,
  DataTable,
  Collapsible,
  Form,
  Loading,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useRef } from "react";
import emptyListImage from "../../Assets/Images/emptyList.svg";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import moment from "moment";
import Select2 from "react-select";
const EditUser = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isSaving, setIsSaving] = useState(true);
  const [item, setItem] = useState({
    access_type: "",
    instructor: "",
    phone: "",
    email: "",
    book_discount: "",
    loyalty_card_number: "",
    loyalty_card_status: "",
  });
  const handleChangeBookDiscount = (newValue) => {
    setItem({ ...item, book_discount: newValue });
  };
  const handleSelectChangeInstructor = (newValue) => {
    setItem({ ...item, instructor: newValue });
  };
  const handleChangeAccessType = (newValue) => {
    setItem({ ...item, access_type: newValue });
  };
  const handleChangePhone = (newValue) => {
    setItem({ ...item, phone: newValue });
  };
  const handleChangeEmail = (newValue) => {
    setItem({ ...item, email: newValue });
    setEmailError("");
  };
  const [emailError, setEmailError] = useState("");
  const [optionsInstructors, setOptionsInstructors] = useState([]);
  const handleChangeLoayltyCardNumber = (newValue) => {
    setItem({ ...item, loyalty_card_number: newValue });
  };
  const handleChangeLoayltyStatus = (newValue) => {
    setItem({ ...item, loyalty_card_status: newValue });
  };
  useEffect(() => {
    fetchData();
  }, []);
  async function fetchData() {
    let responseItem = "";
    let responseInstructors = "";
    try {
      responseItem = await axios.get(`/app/users/${id}`);
      setItem({
        access_type: responseItem?.data?.data?.access_type
          ? String(responseItem.data.data.access_type)
          : "",
        phone: responseItem?.data?.data?.phone_number
          ? responseItem.data.data.phone_number
          : "",
        email: responseItem?.data?.data?.email
          ? responseItem.data.data.email
          : "",
        book_discount:
          responseItem?.data?.data?.book_discount !== null
            ? String(responseItem.data.data.book_discount)
            : "",
        instructor: responseItem?.data?.data?.instructor
          ? {
              label: responseItem?.data?.data?.instructor?.name,
              value: String(responseItem?.data?.data?.instructor?.id),
            }
          : "",
        loyalty_card_number:
          responseItem?.data?.data?.loyalty_card_number || "",
        loyalty_card_status:
          responseItem?.data?.data?.loyalty_card_status || "",
      });
    } catch (error) {
      console.log(error);
    }

    try {
      responseInstructors = await axios.get(
        `/app/user-instructors?per_page=1000`
      );
      setOptionsInstructors(
        responseInstructors.data.data.data.map((item, index) => {
          return {
            label: item.name,
            value: String(item.id),
          };
        })
      );
    } catch (error) {
      console.log(error);
    }
    setIsSaving(false);
  }
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const toastMarkup = active ? (
    <Toast
      content="Changes have been saved successfully"
      onDismiss={toggleActive}
    />
  ) : null;
  return (
    <Page
      backAction={{ onAction: () => navigate("/admin/users") }}
      title={`Edit User`}
      narrowWidth
    >
      {isSaving ? <Loading /> : null}
      <Card>
        <FormLayout>
          <Select
            label="Type"
            options={[
              { label: "Customer", value: "0" },
              { label: "Instructor", value: "200" },
            ]}
            onChange={handleChangeAccessType}
            value={item.access_type}
            placeholder="Please select"
          />
          {item.access_type === "200" ? (
            <FormLayout>
              <Text>Instructor</Text>
              <Select2
                options={optionsInstructors}
                onChange={handleSelectChangeInstructor}
                value={item.instructor}
                placeholder="Please select"
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  menu: (provided) => ({
                    ...provided,
                    maxHeight: "100px",
                    overflowY: "auto",
                  }),
                  menuList: (provided) => ({
                    ...provided,
                    maxHeight: "100px",
                  }),
                }}
                menuPortalTarget={document.body} // THIS IS IMPORTANT
                menuPosition="fixed" // Use fixed instead of absolute
              />
            </FormLayout>
          ) : null}
          <FormLayout.Group>
            <TextField
              value={item.phone}
              onChange={handleChangePhone}
              // error={lastNameError}
              label="Phone Number"
            />
            <TextField
              value={item.email}
              onChange={handleChangeEmail}
              error={emailError}
              label="Email"
            />
          </FormLayout.Group>
          <TextField
            value={item.book_discount}
            onChange={handleChangeBookDiscount}
            // error={lastNameError}
            prefix="%"
            label="Book Discount"
          />
          <FormLayout.Group>
            <TextField
              value={item.loyalty_card_number}
              onChange={handleChangeLoayltyCardNumber}
              label="Loyalty card number"
            />
            <Select
              label="Loyalty card status"
              options={[
                { label: "Active", value: "active" },
                { label: "Inactive", value: "inactive" },
              ]}
              onChange={handleChangeLoayltyStatus}
              value={item.loyalty_card_status}
              placeholder="Please select"
            />
          </FormLayout.Group>

          <div style={{ height: "7rem" }}></div>
        </FormLayout>
      </Card>

      <PageActions
        primaryAction={{
          content: "Save",
          onClick: handleSave,
          loading: isSaving && true,
        }}
      />
      {toastMarkup}
    </Page>
  );
  function handleSave() {
    if (!item.email) {
      setEmailError("This field is required");
    } else {
      setIsSaving(true);
      axios
        .patch(`/app/users/${id}`, {
          access_type: item.access_type,
          instructor_id: item.instructor.value,
          phone: item.phone,
          email: item.email,
          book_discount: item.book_discount,
          loyalty_card_number: item.loyalty_card_number,
          loyalty_card_status: item.loyalty_card_status,
        })
        .then((result) => {
          toggleActive();
          setIsSaving(false);
        })
        .catch((err) => {});
    }
  }
};

export default EditUser;
